import { render } from "./BeginOrderView.vue?vue&type=template&id=4923dbee"
import script from "./BeginOrderView.vue?vue&type=script&lang=js"
export * from "./BeginOrderView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__